// Module
var code = "<uib-tabset type=\"pills\" active=\"$ctrl.index\"> <uib-tab index=\"0\" heading=\"{{'DAPS.TAB.VALIDEE' | translate}}\"> <dap-grid data=\"0\"></dap-grid> </uib-tab> <uib-tab index=\"$index + 1\" heading=\"{{'DAPS.TAB.ATTENTE' | translate}}\"> <dap-attente-grid data=\"1\"></dap-attente-grid> </uib-tab> </uib-tabset>";
// Exports
module.exports = code;